import React from 'react'

import { podAdvantages } from 'pages/DetailProduct/data/advantages'
import { useMobile } from 'utils/mobile'

import BgImagePodAdvantages from 'assets/img/product-details/pod/pod_details.png'

import { colors } from 'styles/colors'

import { Header, Title, Button } from './style'

import {
    Container,
    Body,
    Background,
    Content,
    Item,
    ItemDesc,
    ItemTitle,
    List,
    StyledAccordion,
    MobileSpacer,
    LinkButton
} from './ProductPodAdvantages.style'

const ProductPodAdvantages = () => {
    const mobile = useMobile()

    return (
        <Container>
            <Content>
                <Header>
                    <Title>Gestão simplificada para você, gestor de RH</Title>
                </Header>
                <MobileSpacer />
                <Body>
                    {mobile ? (
                        <List>
                            {podAdvantages
                                .filter((adj) => adj.title)
                                .map((adj) => (
                                    <StyledAccordion
                                        key={adj.title}
                                        title={adj.title}
                                        color={colors.deepPurple}
                                        showArrow
                                    >
                                        <div>{adj.desc}</div>
                                    </StyledAccordion>
                                ))}
                        </List>
                    ) : (
                        <List>
                            {podAdvantages.map((adv) => (
                                <Item key={adv.title}>
                                    {adv.title && (
                                        <ItemTitle>{adv.title}</ItemTitle>
                                    )}
                                    {adv.desc && (
                                        <ItemDesc>{adv.desc}</ItemDesc>
                                    )}
                                </Item>
                            ))}
                        </List>
                    )}
                </Body>
            </Content>
            <Background
                src={BgImagePodAdvantages}
                alt="Beneficios do Alelo Pod"
            />
            <LinkButton className="kkkkk" href="#">
                <Button kind="add">Me interessei!</Button>
            </LinkButton>
        </Container>
    )
}

export default ProductPodAdvantages
